// extracted by mini-css-extract-plugin
module.exports = {"component":"App_component__3-ekW"};